function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.937 26.943c3.57.004 3.022.002 3.998.017.977.015 1.53-.39 1.66-1.16l-.015-3.48c-.002-.651.047-1.303-.3-1.904-.734-1.274-2.35-1.717-3.61-.988-1.26.73-1.687 2.354-.952 3.628a2.664 2.664 0 001.951 1.315c1.891.012 3.312.018 4.26.018 1.028 0 1.118-.84 1.149-1.578.02-.492-.04-2.718-.017-4.299",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.27 19.207c-.095-.665-.307-1.24-.676-1.651l.26.03c6.004.685 10.768 4.118 11.28 10.68-.069 4.537-1.07 8.363-7.406 10.872-.023-.041.011.288 0 2.968-.007 1.7-5.626 1.7-5.63 0v-2.968h-5.526l.025 2.968c-.088 1.698-5.704 1.702-5.686 0v-2.968c-4.797-.366-7.728-1.88-9.256-5.685-.09.009-1.047.006-3.001 0-1.603.206-2.418-.999-2.445-3.614-.026-2.614.62-4.055 1.937-4.321h2.638c1.337-4.153 3.357-6.75 7.978-7.933.014-.95-.021-4.324 0-4.827 3.752-.088 5.204 1.798 5.204 4.827 2.904.005 4.254-.077 5.036-.157a3.251 3.251 0 00-1.317 1.78h-1.65c-.567 0-1.028.46-1.028 1.028v.028c0 .568.46 1.03 1.029 1.03h9.506a1.03 1.03 0 001.03-1.03v-.028a1.03 1.03 0 00-1.03-1.029H29.27z",
  stroke: "#371447",
  fill: "#C0D0D8"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 10.755,
  cy: 25.001,
  rx: 1.156,
  ry: 1.159
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.283 8.945a3.241 3.241 0 00-2.956-4.57 3.241 3.241 0 00-3.239 3.245 3.243 3.243 0 002.903 3.227",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 27.871,
  cy: 12.255,
  rx: 3.238,
  ry: 3.245
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.842 21.192l.082-.243a3.241 3.241 0 00-3.135-4.059 3.241 3.241 0 00-3.153 3.988l.086.349",
  stroke: "#371447"
}));

function SvgCoreSavingsMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCoreSavingsMd;